/* global document */

export default function localizeContent(content) {
    document.querySelector('.js-overlay-list').innerHTML = content.overlayContent;
    document.querySelector('.js-overlay-hide-button').textContent = content.buttonLabel;
}

